import { motion } from "framer-motion";
import { ArrowRight, Sparkles, Star } from "lucide-react";
import { Link } from "react-router-dom";

const Testimonials = () => {
  return (
    <section className="relative py-16 md:py-24 px-6">
      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-[10px] font-mono text-primary uppercase tracking-[0.3em] mb-4">
            Early Access
          </p>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl text-foreground tracking-tight mb-6">
            Be our first case study.
          </h2>
          <p className="text-muted-foreground font-mono text-sm md:text-base leading-relaxed max-w-xl mx-auto mb-8">
            We're onboarding our founding 50 teams. Get lifetime pricing and a dedicated case study feature on our site.
          </p>

          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-primary/20 bg-primary/5 text-[11px] font-mono text-primary">
              <Sparkles className="w-3 h-3" />
              Lifetime discount
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-primary/20 bg-primary/5 text-[11px] font-mono text-primary">
              <Star className="w-3 h-3" />
              Featured on site
            </span>
          </div>

          <Link
            to="/auth"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary text-primary-foreground font-display font-semibold text-sm hover:bg-primary/90 transition-colors"
          >
            Apply for Early Access
            <ArrowRight className="w-4 h-4" />
          </Link>

          <p className="text-[10px] font-mono text-muted-foreground/50 mt-4">
            No credit card required · 14-day free trial
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
